<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset>
    <div style="position:relative!important;">
      <v-sheet>
        <v-btn
          style="z-index:20; position:absolute; top:0; right:0;"
          class="mt-1 mr-1"
          @click="
            () => {
              this['RawMaterial/fetchRawMaterials']({ page: this.page });
              $router.push('/rawMaterial');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card class="elevation-0">
          <v-window v-model="windows" vertical>
            <v-window-item value="details">
              <v-list>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Name</v-list-item-title>
                    <v-list-item-subtitle>{{ rawMaterial.name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Cost</v-list-item-title>
                    <v-list-item-subtitle>{{
                      parseFloat(rawMaterial.cost).toLocaleString()
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Initial Quantity/Weight</v-list-item-title>
                    <v-list-item-subtitle>{{
                      parseFloat(rawMaterial.quantity).toLocaleString()
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Unit</v-list-item-title>
                    <v-list-item-subtitle>{{ rawMaterial.unit_type }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Supplier</v-list-item-title>
                    <v-list-item-subtitle>{{
                      rawMaterial.supplier.company_name
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Specification</v-list-item-title>
                    <v-list-item-subtitle>
                      <ul v-for="specification in rawMaterial.meta">
                        <li>{{ specification['specName'] + ' : ' + specification['value'] }}</li>
                      </ul>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-window-item>
            <v-window-item value="joborder">
              <rawmaterialshowjoborder :job_order_materials="job_order_materials" />
            </v-window-item>
            <v-window-item value="quantity">
              <rawmaterialshowquantity :raw_material_inventories="raw_material_inventories" />
            </v-window-item>
          </v-window>

          <v-card-actions>
            <v-chip class="mx-2" :disabled="windows === 'details'" @click="windows = 'details'">
              Details
            </v-chip>
            <v-chip class="mx-2" :disabled="windows === 'joborder'" @click="windows = 'joborder'">
              Job Order Materials
            </v-chip>
            <v-chip class="mx-2" :disabled="windows === 'quantity'" @click="windows = 'quantity'">
              Additional Quantity
            </v-chip>
            <v-spacer></v-spacer>

            <v-btn @click="deleteRawMaterial" outlined color="red" class="mb-4">
              Delete
            </v-btn>
            <v-btn @click="goToEdit" color="indigo" outlined class="mb-4">
              Edit
            </v-btn>
            <v-btn @click="goToInventory" color="green" outlined class="mb-4">
              Add Quantity
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </div>
    <confirm ref="confirm"></confirm>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import rawmaterialshowjoborder from './RawMaterialShowJobOrder';
import rawmaterialshowquantity from './RawMaterialShowQuantity';
import confirm from '../../components/Confirm.vue';

export default {
  data: function() {
    return {
      windows: 'details'
    };
  },
  components: {
    rawmaterialshowjoborder,
    rawmaterialshowquantity,
    confirm
  },
  props: {
    show: false,
    page: 0
  },
  mounted() {
    if (this.show) {
      this['RawMaterial/getRawMaterial']({ id: this.$route.params.id }).finally(() => {
        if (this.rawMaterial.name == '') {
          this.$router.push('/rawmaterial');
        }
      });
    }
  },
  computed: {
    ...mapState({
      rawMaterial(state) {
        if (typeof state.RawMaterial.rawMaterial.data == 'undefined') {
          return {
            name: '',
            cost: '',
            quantity: '',
            unit_type: '',
            meta: [
              {
                specName: 'size',
                value: 20
              },
              {
                specName: 'weight',
                value: 100
              }
            ],
            supplier: {
              company_name: ''
            },
            job_order_materials: [],
            raw_material_inventories: []
          };
        } else {
          return {
            name: state.RawMaterial.rawMaterial.data.name,
            cost: state.RawMaterial.rawMaterial.data.cost,
            quantity: state.RawMaterial.rawMaterial.data.quantity,
            unit_type: state.RawMaterial.rawMaterial.data.unit_type,
            meta: JSON.parse(state.RawMaterial.rawMaterial.data.meta),
            supplier: state.RawMaterial.rawMaterial.data.supplier,
            job_order_materials: state.RawMaterial.rawMaterial.data.job_order_materials,
            raw_material_inventories: state.RawMaterial.rawMaterial.data.raw_material_inventories
          };
        }
      }
    }),
    job_order_materials: function() {
      return this.rawMaterial.job_order_materials;
    },
    raw_material_inventories: function() {
      return this.rawMaterial.raw_material_inventories;
    }
  },
  methods: {
    ...mapActions(['RawMaterial/fetchRawMaterials', 'RawMaterial/getRawMaterial']),
    deleteRawMaterial() {
      this.$refs.confirm
        .open(
          'Delete Raw Material',
          'Are you sure you want to delete raw material ' + this.rawMaterial.name + '?',
          { color: '#f44336' }
        )
        .then(confirm => {
          axios
            .delete(`api/v1/rawmaterial/${this.$route.params.id}`)
            .then(response => {
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Raw material deleted...',
                color: 'success'
              });
              this['RawMaterial/fetchRawMaterials']({ page: this.page });
              this.$router.push('/rawmaterial');
            })
            .catch(error => {
              if (error.response.status == 403) {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              } else {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data.errors['id'][0],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {});
        });
    },
    goToEdit() {
      this.$router.push(`/rawmaterial/${this.$route.params.id}/edit`);
    },
    goToInventory() {
      this.$router.push(`/rawmaterial/${this.$route.params.id}/inventory`);
    }
  }
};
</script>
